import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyBzDENoTlCKoQuCvU3TQjP0nGEIODAVxXg',
		libraries: 'places',
		region: 'ID',
		language: 'id',
	},
	installComponents: true
})

export default VueGoogleMaps